export type ConsoleLevel = 'log' | 'info' | 'warn' | 'error' | 'debug';

export const CONSOLE_LEVELS: ConsoleLevel[] = ['log', 'info', 'warn', 'error', 'debug'];

export interface ConsoleEntry {
  id: string;
  level: ConsoleLevel;
  args: unknown[];
  timestamp: number;
  /** First stack frame outside the dev-console service (best-effort). */
  source?: string;
  /** Number of consecutive duplicate messages grouped into this entry (#51). */
  repeatCount?: number;
  /** Whether this entry is pinned to the top (#52). */
  pinned?: boolean;
}
